<div class="box-padding">
  <div class="sample-text d-flex justify-content-end mb-3">
    <button nz-button nzType="default" type="button" class="ant-btn colorBtn" (click)="downloadSampleFile()">
      <i nz-icon nzType="download" nzTheme="outline" class="fs-20"></i>
      <span>{{ 'FILE.DOWNLOAD_TEMPLATE' | translate }}</span>
    </button>
  </div>
  <nz-upload *ngIf="!uploadFile" nzType="drag" [nzBeforeUpload]="handleUpload" [nzCustomRequest]="customUpload"
    [nzShowUploadList]="false" [nzAccept]="'.xlsx, .xls'">
    <i nz-icon nzType="icons:mail" nzTheme="outline" aria-hidden="true" class="upload_icon fs-24"></i>
    <p class="ant-upload-text"><span class="upload-text">{{ 'FILE.CHOOSE_FILE' | translate }}</span></p>
    <p class="ant-upload-hint">
      <ng-container *ngIf="!unlimited">
       {{'FILE.MAX_FILE_UPLOAD' | translate }}
      </ng-container>
      <ng-container *ngIf="unlimited">
        {{ 'FILE.MAX_FILE_UPLOAD_2' | translate }}
      </ng-container>
    </p>
    <p style="color:#EA5455; font-style: italic;">
      {{ 'FILE.SUPPORTED_FORMAT' | translate }}
    </p>
  </nz-upload>
  <div *ngIf="uploadFile" class="flex-container">
    <div class="icon"><i nz-icon nzType="icons:excel-icon" nzTheme="outline" aria-hidden="true"></i></div>
    <div class="file-name">
      <div>{{uploadFile.name}}</div>
      <div>{{fileSize}} MB</div>
      <nz-progress *ngIf="isUploading" [nzPercent]="progress" [nzStrokeWidth]="10"
        [nzStrokeColor]="'#F86E0B'"></nz-progress>
    </div>
    <div class="icon" style="cursor: pointer;" (click)="onRemoveFile()"><i nz-icon nz-tooltip nzTooltipTitle="{{'BUTTON.DELETE' |  translate}}"
        nzTooltipPlacement="top" nzType="icons:delete-icon" nzTheme="outline" aria-hidden="true"></i></div>
  </div>

  <ng-container *ngIf="uploadFile && !isUploading && uploadResult">
    <!-- <div *ngIf="uploadResult?.fileName" class="message-textbox message-textbox-success">
      Nội dung file hợp lệ!
    </div> -->
    <div *ngIf="uploadResult?.fileName" class="message-textbox message-textbox-error">
      <span>{{ 'FILE.INVALID_CONTENT' | translate }}</span>
      <!-- {{uploadResult?.message}} -->
      <!-- <div>File có định dạng không đúng!</div>
      <div>{{uploadResult?.successRecord}} bản ghi hợp lệ.</div>
      <div>{{uploadResult?.errorRecord}} bản ghi không hợp lệ.</div> -->
      <div class="sample-text" (click)="downloadResultFile()">{{ 'FILE.DOWNLOAD_RESULT_FILE' | translate }}: <a>{{uploadResult?.fileName}}</a></div>
    </div>
  </ng-container>
</div>

<hr class="m-0 split-line" />
<div class="c-modal-footer">
  <div class="content text-center">
    <button nz-button nzType="default" class="ant-btn" style="margin-right: 1rem;" type="button"
      (click)="onCloseModal()">
      <i nz-icon [nzType]="'icons:arrow-back-up'" class="fs-20" nzTheme="outline" aria-hidden="true"></i>
      <span>{{ 'BUTTON.BACK' | translate }}</span>
    </button>
    <button nz-button nzType="primary" class="ant-btn button-submit" style="min-height: 31px;" type="button" (click)="onPreview()"
      [disabled]="disablePreview">
      <i nz-icon [nzType]="'check-circle'" nzTheme="outline" aria-hidden="true"></i>
      <span>{{ 'BUTTON.SAVE' | translate }}</span>
    </button>

  </div>
</div>
